module.exports = __webpack_public_path__ + "static/media/16UNODC37.5f992dad.jpg";